export default "<mat-spinner *ngIf=\"loader\"></mat-spinner>";